var exports = {
  "kL": "GuildIcon.module__container___anhYbX",
  "qJ": "GuildIcon.module__containerNoIcon___anhYbX",
  "yC": "GuildIcon.module__initials___anhYbX",
};

module.exports = exports;
